var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { EmployeeProfileQueryKey } from './queryKey';
export var useCreateEmployeeProfile = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (model) {
        return api.base
            .post('/api/employeeProfile', model)
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function (result) {
            if (!result)
                return;
            queryClient.setQueryData([EmployeeProfileQueryKey.EmployeeProfiles], function (old) { return (old ? __spreadArray(__spreadArray([], old, true), [result], false) : [result]); });
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { createProfile: mutateAsync, isLoading: isLoading };
};
export var useUpdateEmployeeProfile = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (model) {
        return api.base.put('/api/employeeProfile', model).then(function (res) { return res.data; });
    }, {
        onSuccess: function () {
            queryClient.invalidateQueries([EmployeeProfileQueryKey.EmployeeProfiles]);
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { updateProfile: mutateAsync, isLoading: isLoading };
};
export var useDeleteEmployeeProfile = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (id) {
        return api.base.delete("/api/employeeProfile/Delete/".concat(id)).then(function () { return id; });
    }, {
        onSuccess: function (deletedId) {
            queryClient.setQueryData([EmployeeProfileQueryKey.EmployeeProfiles], function (old) { return (old ? old.filter(function (e) { return e.id !== deletedId; }) : old); });
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { deleteProfile: mutateAsync, isLoading: isLoading };
};
export var useSetDefaultEmployeeProfile = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (id) {
        return api.base
            .put("/api/employeeProfile/SetDefault/".concat(id))
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function (updatedProfiles) {
            if (!(updatedProfiles === null || updatedProfiles === void 0 ? void 0 : updatedProfiles.length))
                return;
            queryClient.setQueryData([EmployeeProfileQueryKey.EmployeeProfiles], function (old) {
                if (!old)
                    return old;
                return old.map(function (profile) {
                    var updated = updatedProfiles.find(function (p) { return p.id === profile.id; });
                    return updated ? __assign(__assign({}, profile), { isDefault: updated.isDefault }) : profile;
                });
            });
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { setDefault: mutateAsync, isLoading: isLoading };
};
